import { css } from 'lit'

export default css`
    :host {
        display: inline-flex;
    }

    .external-link {
        display: inline-flex;
        word-break: break-all;
        align-items: flex-start;
        gap: 4px;
        color: var(--grey-700);
        text-decoration: underline;
    }

    .external-link:hover,
    .external-link:hover .external-link-icon {
        color: var(--blue-500);
    }

    .external-link-icon {
        color: var(--grey-600);
    }
`
